import { isString, sanitizeBindable, sanitizeString } from './helpers';
function sanitizeSvgString(value) {
  if (!isString(value)) return undefined;
  const trimmed = value.trim();
  // Reject content that isn't SVG or contains obviously unsafe patterns.
  // Full DOM sanitization happens at render time via sanitizeSvgMarkup.
  if (!trimmed.toLowerCase().startsWith('<svg')) return undefined;
  if (/javascript:/i.test(trimmed)) return undefined;
  if (/<script/i.test(trimmed)) return undefined;
  return trimmed;
}
export function sanitizeSvgIcon(el) {
  const svg = sanitizeBindable(el.svg, sanitizeSvgString);
  if (svg === undefined) return null;
  return {
    type: 'SvgIcon',
    svg,
    ariaLabel: sanitizeBindable(el.ariaLabel, sanitizeString)
  };
}